import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";
import { useSettings } from "@/context/SettingsContext";

const LEGAL = [
  { label: "Terms of Use", to: "/terms", testId: "footer-terms" },
  { label: "Privacy Policy", to: "/privacy", testId: "footer-privacy" },
  { label: "Cookie Policy", to: "/cookies", testId: "footer-cookies" },
  { label: "Service & Enquiry Terms", to: "/service-terms", testId: "footer-service-terms" },
  { label: "Intellectual Property", to: "/intellectual-property", testId: "footer-ip" },
];

export default function Footer() {
  const { settings } = useSettings();
  const { company, socials } = settings;
  return (
    <footer className="bg-lux-bg">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-12 py-12 md:py-20 flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div className="flex flex-col gap-2">
          <Logo height={30} testId="footer-logo" />
          <div className="h-1.5" />
          <p className="text-[13px] text-lux-sec font-light">We begin with YÜ.</p>
          <p className="text-[13px] text-lux-sec font-light">{company.tagline}</p>
          {company.address ? <p className="text-xs text-lux-muted mt-1.5 font-light">{company.address}</p> : null}
        </div>

        <div className="flex flex-col md:items-end gap-2.5">
          <Link to="/understanding-yu" data-testid="footer-understanding-yu" className="text-xs tracking-[0.12em] uppercase text-lux-muted underline underline-offset-2 decoration-lux-lineStrong">
            Understanding YÜ
          </Link>
          <Link to="/1618" data-testid="footer-hidden-ratio" className="font-serif text-[11px] tracking-[0.35em] text-lux-muted opacity-60">
            1.618
          </Link>
          <div className="h-2" />
          <span className="text-[10px] tracking-[0.25em] text-lux-muted">FOLLOW</span>
          <div className="flex items-center gap-4 mt-1">
            <a href={socials.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="text-lux-ink hover:text-lux-accent transition-colors">
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a href={socials.linkedin_url} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="footer-social-linkedin" className="text-lux-ink hover:text-lux-accent transition-colors">
              <Linkedin size={18} strokeWidth={1.5} />
            </a>
          </div>
          <div className="h-4" />
          <span className="text-[10px] tracking-[0.25em] text-lux-muted">LEGAL</span>
          <div className="flex flex-col md:items-end gap-1.5 mt-1.5">
            {LEGAL.map((l) => (
              <Link key={l.to} to={l.to} data-testid={l.testId} className="text-[11px] text-lux-muted hover:text-lux-ink transition-colors">
                {l.label}
              </Link>
            ))}
          </div>
          <div className="h-4" />
          <span className="text-[11px] text-lux-muted" data-testid="footer-copyright">© UNA.6. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
